export enum DataType {
  STRING = 'string',
  BOOLEAN = 'boolean',
  INT64 = 'int64',
}
